import { Injectable } from '@angular/core';

export interface AppContext {
  journalCode: string;
  languageCode: string;
  peopleIdentifier: string;
  role: string;
  questionnaireId: string;
}

@Injectable({ providedIn: 'root' })
export class ContextService {

  private readonly storageKey = 'demographics_app_context';

  setContext(ctx: AppContext): void {
    sessionStorage.setItem(this.storageKey, JSON.stringify(ctx));
  }

  getContext(): AppContext | null {
    const raw = sessionStorage.getItem(this.storageKey);
    if (!raw) {
      return null;
    }
    try {
      return JSON.parse(raw) as AppContext;
    } catch (e) {
      console.error('Invalid stored context', e);
      return null;
    }
  }

  clear(): void {
    sessionStorage.removeItem(this.storageKey);
  }

  hasContext(): boolean {
    return this.getContext() !== null;
  }
}
